import { Minus, Plus } from "lucide-react";

export const Stepper = ({ value, min = 0, max = 20, onChange, label, testId }) => (
  <div className="inline-flex items-center rounded-full border border-[#D4A359]/35 bg-[#0B2216]/60">
    <button type="button" aria-label={`Retirer ${label}`} onClick={() => onChange(Math.max(min, value - 1))} disabled={value <= min} className="w-8 h-8 flex items-center justify-center text-[#F7F4EB] disabled:opacity-30" data-testid={`${testId}-minus`}>
      <Minus className="w-3.5 h-3.5" />
    </button>
    <span className="w-7 text-center text-sm text-[#F7F4EB]" data-testid={`${testId}-value`}>{value}</span>
    <button type="button" aria-label={`Ajouter ${label}`} onClick={() => onChange(Math.min(max, value + 1))} disabled={value >= max} className="w-8 h-8 flex items-center justify-center text-[#F7F4EB] disabled:opacity-30" data-testid={`${testId}-plus`}>
      <Plus className="w-3.5 h-3.5" />
    </button>
  </div>
);
